import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import PostsList from './PostsList';

class Bits extends Component {
  componentWillMount() {
  }

  render() {
    return (
      <div className="main-index main-index--bits">
        <Helmet>
          <title>Bits & Pieces from Dan</title>
        </Helmet>
        <div className="index-page-buffer" />
        <div className="grid-row grid-8">
          <div className="grid-cell grid-cell--no-padding">
            <p className="quote">
              <q className="quote__text">Nothing is a mistake. <br />There’s no win and no fail. <br />There’s only&nbsp;make.</q>
              <span className="quote__author">John Cage</span>
            </p>

          </div>
        </div>
        <PostsList posts={this.props.posts} postType="BlogPosts" loadData={this.props.loadData} />
      </div>
    );
  }
}

Bits.propTypes = {
  posts: PropTypes.arrayOf(PropTypes.object).isRequired,
  loadData: PropTypes.func.isRequired,
};

export default Bits;



// WEBPACK FOOTER //
// ./src/components/Bits.js